import dark_theme  from './themes/dark';
import light_theme  from './themes/light';
import color_theme from './themes/color';

const map_themes = {
    dark:dark_theme,
    light:light_theme,
    color:color_theme
}
let map;
let cur_infowindow;
// initialise le bloc google map
async function initGoogleMapBlock(){
    const  mapData = await wp.apiFetch({path:"/cdm-map/map_data/"}).then(json=>json); //Données viennent du endpoint savé dans functions.php du block
    const container = document.querySelector("#cdm-map");
    if(!container){
        console.error('Google map codems block: check if container exists.')
        return;
    };
    if( !window.google){
        console.error('Google map codems block: check if google map is enqueued. (is the "GOOGLE_MAP_API" constant defined in wp-config?)')
        return;
    };
    if(!window.google.maps){
        console.error('Google map codems block: check if google map is enqueued. (is the "GOOGLE_MAP_API" constant defined in wp-config?)')
        return;
    };

    const theme = map_themes[container.getAttribute('data-theme')];

    const mapOptions = {
        zoom: 12,
        scrollwheel : false,
        zoomControl: true,
        disableDefaultUI: true,
        iconColor:container.getAttribute('data-icon-color'),
        // center: markerPos, //TODO
        center: new google.maps.LatLng(mapData.main_address.lat,mapData.main_address.lng),
        labelContent: mapData.site_name, //TODO
        mapTypeControlOptions: {
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, theme.id]
        },
        mapTypeId: theme.id
    }

    map = new google.maps.Map(container, mapOptions);
    map.mapTypes.set(theme.id,  new google.maps.StyledMapType(theme.theme, {name:theme.id}));

    const bounds = new google.maps.LatLngBounds();
    cdmMapAddMarker(map,bounds,mapData.main_address,mapData.site_logo);
    if(mapData.other_point){
        for (const [key, value] of Object.entries(mapData.other_point)) {
            if(value.image_map){
                var image = '\t<div class="site-branding">\r\n\t\t\t\t\t\t\t<a href="https://localhost/" rel="home" class="site-logo"><img src="' + value.image_map +'"/></a></div>'
                cdmMapAddMarker(map,bounds,value.adresses,image);
            }else{
                cdmMapAddMarker(map,bounds,value.adresses,mapData.site_logo);
            }
           
        }
        map.fitBounds(bounds,155);
        
    }
    container.classList.remove('loading');
}

function cdmMapAddMarker(map,bounds,acf_adress,logo = "",icon = null){
    const defaultIcon = {
            path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
            fillColor: map.iconColor,
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            scale: 0.1,
            anchor: new google.maps.Point(150, 500),
    }

    const marker = new google .maps.Marker({
        position: new google.maps.LatLng(acf_adress.lat, acf_adress.lng),
        map: map,
        icon: icon?icon:defaultIcon,
    });

    const infoWindow = new google.maps.InfoWindow({
        content: `  <div class="content-infopup-wrapper">
                        ${logo}
                        <a data-direction="${acf_adress.address}" href="https://www.google.ca/maps/dir//${encodeURIComponent(acf_adress.address)}" target="_blank" rel="nooponer">${acf_adress.address}</a>
                        <a data-direction="${acf_adress.address}" href="https://www.google.ca/maps/dir//${encodeURIComponent(acf_adress.address)}" target="_blank" rel="nooponer">${wp.i18n._x('Directions','cdm-map','theme_client')}</a>
                    </div>`
    });


    marker.addListener('click', function() {
        if (cur_infowindow) {
            cur_infowindow.close();
        }
        cur_infowindow = infoWindow;
        infoWindow.open(map, marker);
    });

    bounds.extend(new google.maps.LatLng(acf_adress.lat, acf_adress.lng));
}


cdm_blocks.fn.ready(()=>{
    if(!document.body.classList.contains('wp-admin') ){
        initGoogleMapBlock();
    }
});

